import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import './style.css';

const CarrosselNoticias = ({ lnoticias }) => {
  // Extrai as notícias do formato news_results
  const noticias = lnoticias?.news_results || [];

  const responsive = {
    superLargeDesktop: {
      // screens larger than 1920px
      breakpoint: { max: 4000, min: 1920 },
      items: 4
    },
    desktop: {
      // screens larger than 1024px
      breakpoint: { max: 1920, min: 1024 },
      items: 4
    },
    tablet: {
      // screens larger than 464px
      breakpoint: { max: 1024, min: 768 },
      items: 3
    },
    mobile: {
      // screens smaller than 464px
      breakpoint: { max: 768, min: 0 },
      items: 1
    }
  };

  return <>
    <div className='mt-3'>
      <h1 id="Noticias">
       Notícias
      </h1>
      <Carousel responsive={responsive} infinite={true} className="mt-3">
        {noticias && noticias.map((noticia, index) => {
          const thumbnailValido = noticia.thumbnail && noticia.thumbnail !== '' && !noticia.thumbnail.endsWith('/');
          return (
          <div key={`noticia${index}`} className='p-2'>
            <div className="card h-100" style={{ maxWidth: '300px' }}>
              {thumbnailValido && (
                <img 
                  src={noticia.thumbnail} 
                  className="card-img-top" 
                  alt={noticia.title}
                  style={{ width: '100%', height: '150px', objectFit: 'cover' }}
                />
              )}
              <div className="card-body d-flex flex-column">
                <h5 className="card-title" style={{ fontSize: '14px', lineHeight: '1.2' }}>
                  {noticia.title}
                </h5>
                <div className="mt-auto">
                  <small className="text-muted d-block mb-2">
                    <strong>Fonte:</strong> {noticia.source?.name || 'Fonte não disponível'}
                  </small>
                  <small className="text-muted d-block mb-2">
                    <strong>Publicado:</strong> {noticia.date}
                  </small>
                  <a 
                    href={noticia.link} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="btn btn-primary btn-sm w-100"
                  >
                    Ler mais
                  </a>
                </div>
              </div>
            </div>
          </div>
          );
        })}
      </Carousel>
    </div>
  </>
};

export default CarrosselNoticias;
